import { render, staticRenderFns } from "./AguardandoProcessamento.vue?vue&type=template&id=1476c8c7"
import script from "./AguardandoProcessamento.vue?vue&type=script&lang=js"
export * from "./AguardandoProcessamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports